import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'

type Props = {
  text: string | React.ReactNode
  showRequired?: boolean
  className?: string
}

export const FormItemTitle: FC<Props> = ({ text, showRequired = false, className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-flex-nowrap tw-items-center tw-gap-r-3">
        <Txt>{text}</Txt>
        {showRequired && <Txt className="tw-text-errorRed-default tw-font-bold">*</Txt>}
      </div>
    </div>
  )
}
